import axiosService from "services/axios.service";

export const getPageHeader = async () => {
  try {
    const response = await axiosService.get("/v1/admin/page-headers");
    return response?.data.data;
  } catch (error) {
    console.log(error);
  }
};

export const updatePageHeader = async (payload: any): Promise<any> => {
  const response = await axiosService.put("v1/admin/page-headers", payload);
  return response?.data.data;
};
